import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';
import { RootState } from '@/lib/store';
import useTranslation from 'next-translate/useTranslation';
import { resetSearcHistory } from '@/lib/store/casino/actions';

export default function SearchHistoryHeader() {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const searchHistory = useSelector(
    (state: RootState) => state.casino.searchHistory,
  );
  const count: number = searchHistory.length;

  function handleReset() {
    dispatch(resetSearcHistory());
  }

  return (
    <div className={styles.container}>
      <span className={styles.container__title}>
        {t('search_history_label')}
      </span>

      <button
        className={styles['container__label-button']}
        onClick={handleReset}
      >
        {t('clean_search_history_label', {
          count: count >= 99 ? `${count}+` : count,
        })}
      </button>
    </div>
  );
}
